import { render, staticRenderFns } from "./FiniquitoShowEdit.vue?vue&type=template&id=f8ba8582&lang=pug&"
import script from "./FiniquitoShowEdit.vue?vue&type=script&lang=js&"
export * from "./FiniquitoShowEdit.vue?vue&type=script&lang=js&"
import style0 from "./FiniquitoShowEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FiniquitoShowEdit.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VContainer,
  VFlex,
  VIcon,
  VLayout,
  VSpacer,
  VToolbar,
  VToolbarTitle,
})
